import BootstrapFail from './bootstrap-fail-container';

export default BootstrapFail;
